module.exports = __webpack_public_path__ + "img/k22.6363a339.jpg";